import i18n from '../../locales/index'
import restful from '../vuex'

const state = {
  ...restful.states('message')
}

const getters = {
  ...restful.getters('message')
}

const actions = {
  ...restful.actions('messages')
}

const mutations = {
  ...restful.mutations('message')
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
